export const LOSS_REASON_FORM = "configLossReason";